import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./styles.module.scss";
import { Link } from "react-router-dom";
const Breadcrumb = ({ links, }) => {
    const linkElements = links.map((link, i) => {
        if (i < links.length - 1) {
            return (_jsxs(React.Fragment, { children: [_jsx(Link, { to: link.href, children: link.title }), " ", _jsx("span", { className: styles.breadcrumbSlash, children: "/" }), " "] }, link.title));
        }
        return (_jsx(Link, { className: styles.breadcrumbEnd, to: link.href, children: link.title }, link.title));
    });
    return _jsx("div", { className: styles.breadcrumb, children: linkElements });
};
export default Breadcrumb;
